export const BANNER_TYPE = {
  webinar: 'webinar',
  performancePredictions: 'performancePredictions',
};
